module.exports = __webpack_public_path__ + "static/media/2_The inner voice_ES.35f70fbf.txt";